export default "__VITE_ASSET__B1YKm4t6__"